import { SxProps } from '@mui/material'

import theme from '../../styles/themes/default.theme'

const styles = {
  footer: {
    display: 'inline-flex',
    alignItems: 'center',
    color: theme.palette.text.secondary,
    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
    fontSize: 11,
    letterSpacing: 0.2,
    opacity: 0.7,
    userSelect: 'all',
    lineHeight: 1
  } as SxProps,

  overlay: {
    position: 'fixed',
    bottom: 8,
    left: 8,
    zIndex: theme.zIndex.snackbar - 2,
    display: 'inline-flex',
    alignItems: 'center',
    maxWidth: 'calc(100vw - 16px)',
    padding: theme.spacing(0.25, 0.75),
    borderRadius: 1,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    color: theme.palette.text.secondary,
    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
    fontSize: 10,
    letterSpacing: 0.2,
    opacity: 0.55,
    pointerEvents: 'auto',
    userSelect: 'all',
    lineHeight: 1.4,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    transition: 'opacity 180ms ease',
    '&:hover': { opacity: 1 },
    '&:hover .version-details': { gridTemplateColumns: '1fr' }
  } as SxProps,

  overlayVersion: {
    flex: '0 0 auto'
  } as SxProps,

  overlayDetails: {
    display: 'inline-grid',
    gridTemplateColumns: '0fr',
    transition: 'grid-template-columns 240ms ease',
    minWidth: 0
  } as SxProps,

  overlayDetailsInner: {
    minWidth: 0,
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  } as SxProps
}

export default styles
